import React from "react";
import { FloatingMenuItem } from "./floating-menu-item";
import { useCdnUrl } from "../../hooks/useCdnUrl";

export function ResetCdnUrlMenuItem() {
	const [cdnUrl, setCdnUrl] = useCdnUrl();

	if (!cdnUrl) return null;

	return (
		<FloatingMenuItem
			text="Reset version"
			badgeType={"error"}
			iconName="offline"
			onClick={() => {
				setCdnUrl(undefined);
			}}
		/>
	);
}
